/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PresignViewResponse
 */
export interface PresignViewResponse {
    /**
     * 
     */
    url?: string;
}

/**
 * Check if a given object implements the PresignViewResponse interface.
 */
export function instanceOfPresignViewResponse(value: object): value is PresignViewResponse {
    return true;
}

export function PresignViewResponseFromJSON(json: any): PresignViewResponse {
    return PresignViewResponseFromJSONTyped(json, false);
}

export function PresignViewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresignViewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function PresignViewResponseToJSON(json: any): PresignViewResponse {
    return PresignViewResponseToJSONTyped(json, false);
}

export function PresignViewResponseToJSONTyped(value?: PresignViewResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

